/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const useGoalPageStaticContent = (
  goalUID,
  options = { selector: null, fallbackData: undefined }
) => {
  const key = `api/pre-subscribed-goal-info/${goalUID}`;

  const {
    data: goalStaticContent,
    isValidating,
    ...rest
  } = useFetch(
    key,
    { hostType: HOST_TYPE.CMS },
    { fallbackData: options.fallbackData }
  );

  if (options.selector && typeof options.selector === 'function')
    return options.selector(goalStaticContent || {});
  return {
    key,
    goalStaticContent,
    isValidating,
    ...rest
  };
};

export default useGoalPageStaticContent;
